(() => {
 const script = document.querySelector('script[data-cookie-copy]');
 const apply = () => {
  const banner = document.querySelector('#shopify-pc__banner');
  if (!banner || !script) return false;
  const paragraph = banner.querySelector('.shopify-pc__banner__body p');
  const policy = paragraph?.querySelector('a');
  if (paragraph && policy) paragraph.replaceChildren(document.createTextNode(script.dataset.cookieCopy + ' '), policy);
  const preferences = banner.querySelector('#shopify-pc__banner__btn-manage-prefs span');
  if (preferences) preferences.textContent = document.documentElement.lang.startsWith('en') ? 'Preferences' : script.dataset.preferencesLabel;
  return true;
 };
 if (apply()) return;
 const observer = new MutationObserver(() => { if (apply()) observer.disconnect(); });
 observer.observe(document.body, { childList: true, subtree: true });
})();
